"use client";
import { Button } from "@/components/ui/button";
import { Link } from "@/i18n/routing";
import useLocalizer from "@/hooks/useLocalizer";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils/utils";
import { Activity, useEffect, useState } from "react";
import React from "react";
import Flex from "@/components/core/flex";

interface SidebarMenuItemProps {
  title: string;
  href: string;
  items?: SidebarMenuItemProps[];
}

interface SidebarMenuProps {
  items: SidebarMenuItemProps[];
}

const SidebarMenu: React.FC<SidebarMenuProps> = ({ items }) => {
  const { isRtl, t } = useLocalizer();
  const [open, setOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);
  useEffect(() => {
    console.log(activeIndex);
  }, [activeIndex]);
  return (
    <Flex direction="col" spacing={{ all: 2 }} className="px-4">
      <ul className="flex flex-col w-full h-full gap-4 text-white">
        {items?.map((item, index) => (
          <li
            key={index}
            className="flex flex-col gap-2 border-b border-primary/20 pb-2"
          >
            <Flex direction="row" spacing={{ all: 2 }} className="font-medium">
              <Link
                href={item.href}
                title={item.title}
                className="hover:text-secondary-foreground h-full w-full block"
              >
                {item.title}
              </Link>
              {item?.items && item?.items?.length > 0 && (
                <Button
                  onClick={() => {
                    setOpen(!open);
                    setActiveIndex(index);
                  }}
                  className={cn(
                    "rounded-none h-8 w-8 duration-300 ease-in-out",
                    open ? "-rotate-90" : "rotate-0",
                  )}
                  aria-label={open ? t("buttons.close") : t("buttons.open")}
                >
                  {isRtl ? <ChevronLeft /> : <ChevronRight />}
                </Button>
              )}
            </Flex>
            {
              <Activity
                mode={open && activeIndex === index ? "visible" : "hidden"}
              >
                <ul className="flex flex-col gap-4 px-2">
                  {item?.items?.map((subItem, subIndex) => (
                    <li
                      key={subIndex}
                      className="border-b border-primary/20 pb-2 last:border-b-0 h-full w-full"
                    >
                      <Link
                        href={subItem.href}
                        title={subItem.title}
                        aria-label={subItem.title}
                        className="hover:text-secondary-foreground h-full w-full block"
                      >
                        {subItem.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </Activity>
            }
          </li>
        ))}
      </ul>
    </Flex>
  );
};

export default SidebarMenu;
